import { Box, Slider, Typography } from "@mui/material";
import { useState } from "react";
import { percentage } from "../../../shared/percentage";
import { TABULAR_NUMERALS } from "../../general/dataAtoms/shared";

const STEP = 5;
/** Wide enough for 100%, so the row does not move as the figure grows. */
const FIGURE_WIDTH = 44;

/**
 * A share as a slider with its figure beside it. The figure follows the thumb;
 * the share is reported once, when it is released.
 */
export const PercentSlider = ({
  value,
  label,
  disabled = false,
  onDrag,
  onChange,
}: {
  value: number;
  label: string;
  disabled?: boolean;
  onDrag?: (value: number) => void;
  onChange: (value: number) => void;
}) => {
  const [dragged, setDragged] = useState<number>();
  const shown = dragged ?? value * 100;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flex: 1,
        minWidth: 0,
      }}
    >
      <Slider
        size="small"
        value={shown}
        step={STEP}
        disabled={disabled}
        aria-label={label}
        onChange={(_, next) => {
          if (typeof next !== "number") return;
          setDragged(next);
          onDrag?.(next / 100);
        }}
        onChangeCommitted={(_, next) => {
          if (typeof next === "number") onChange(next / 100);
          setDragged(undefined);
        }}
      />
      <Typography
        variant="body2"
        component="span"
        sx={{
          flex: "none",
          width: FIGURE_WIDTH,
          textAlign: "right",
          fontWeight: 600,
          ...TABULAR_NUMERALS,
        }}
      >
        {percentage.format(shown / 100)}
      </Typography>
    </Box>
  );
};
